module.exports = __WEBPACK_EXTERNAL_MODULE_42__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","differenceInSeconds"],"commonjs":"date-fns/difference_in_seconds/index","commonjs2":"date-fns/difference_in_seconds/index","amd":"date-fns/difference_in_seconds/index"}
// module id = 42
// module chunks = 0